import { atom } from 'recoil';
import type { VSGAPayload } from '~/lib/types';

export const scrollToFieldAtom = atom<string | null>({
  key: '@zurich/vsga/stepper/scrollToField',
  default: null,
});

export const activeStepAtom = atom({
  key: '@vsga/activeStepAtom',
  default: 0,
});

export const showDamageContentAtom = atom<boolean>({
  key: '@vsga/showDamageContentAtom',
  default: false,
});

export const editDamageId = atom<string | undefined>({
  key: '@vsga/editDamageId',
  default: undefined,
});

export const confirmationOfCorrectPhotoDataAtom = atom<boolean | null>({
  key: '@vsga/confirmationOfCorrectPhotoDataAtom',
  default: null,
});

export const vsgaPayloadAtom = atom<VSGAPayload>({
  key: '@vsga/vsgaPayloadAtom',
  default: {
    photos: [],
    damages: [],
    serialNumber: '',
  },
});
